import {
  GET_COSMETOLOGIC_FEE_BY_COSMETOLOGIST,
  GET_DAILY_CASH_CLOSING,
  GET_DAILY_SALES,
  GET_EXPENSES_BY_BRANCH,
  GET_GENERAL_APPOINTMENTS,
  GET_GENERAL_COSMETOLOGIC_FEES,
  GET_GENERAL_CUSTOMER,
  GET_GENERAL_EXPENSES,
  GET_GENERAL_INVENTORY,
  GET_INDIVIDUAL_COMMISSION_MEDICAL,
  GET_MEDICAL_COMMISSIONS_BY_BRANCH,
  GET_MONTHLY_SALES,
  GET_APPOINTMENT_CONFIRMATION_PERCENTAGE_BY_BRANCH,
  GET_PROFITABILITY_BY_BRANCH,
  GET_SCHEDULED_APPOINTMENTS,
  GET_STOCK_BY_BRANCH,
  GET_OCCUPATION_BY_BRANCH,
  CLEAR_GENERAL_APPOINTMENT,
  CLEAR_GENERAL_CUSTOMER,
  CLEAR_MEDICAL_COMMISSION,
  CLEAR_COSMETOLOGISC_FEES_BY_COMESTOLOGIST,
  CLEAR_BRANCH_EXPENSES,
  CLEAR_DAILY_CASH_CLOSING,
  CLEAR_GENERAL_EXPENSES,
  CLEAR_GENERAL_INVENTORY,
  CLEAR_GENERAL_INVENTORY_FILTERS,
  CLEAR_MEDICAL_COMMISSIONS_BY_BRANCH,
  CLEAR_MONTHLY_SALES,
  CLEAR_APPOINTMENT_CONFIRMATION_PERCENTAGE_REPORT_BY_BRANCH_FILTERS,
  CLEAR_PROFITABILITY_BY_BRANCH,
  CLEAR_GENERAL_SCHEDULED_APPOINTMENT,
  CLEAR_STOCK_BY_BRANCH_REPORT,
  CLEAR_DAILY_SALES,
  CLEAR_GENERAL_COSMEOTLOGIC_FEES,
  CLEAR_INDIVIDUAL_COMMISSION_MEDICAL,
  CLEAR_OCCUPATION_BY_BRANCH
} from '../types';

const initialState = {
  stockByBranch: [],
  expensesByBranch: [],
  medicalComissionByBranch: [],
  generalInventory: [],
  generalExpenses: [],
  profitabilityByBranch: [],
  appointmentConfirmationPercentageByBranch: [],
  generalCustomer: [],
  generalAppointment: [],
  generalCosmetologicFees: [],
  cosmetologicFeesByCosmetologist: [],
  generalScheduledAppointments: [],
  individualCommissionMedical: [],
  dailySales: [],
  monthlySales: [],
  dailyCashClosing: [],
  occupationByBranch: [],
};

export default function Reports(state = initialState, action) {
  switch (action.type) {
    case GET_STOCK_BY_BRANCH:
      return {
        ...state,
        stockByBranch: action.payload,
      };
    case GET_EXPENSES_BY_BRANCH:
      return {
        ...state,
        expensesByBranch: action.payload,
      };
    case GET_MEDICAL_COMMISSIONS_BY_BRANCH:
      return {
        ...state,
        medicalComissionByBranch: action.payload,
      };
    case GET_GENERAL_INVENTORY:
      return {
        ...state,
        generalInventory: action.payload,
      };
    case GET_GENERAL_EXPENSES:
      return {
        ...state,
        generalExpenses: action.payload,
      };
    case GET_PROFITABILITY_BY_BRANCH:
      return {
        ...state,
        profitabilityByBranch: action.payload,
      };
    case GET_APPOINTMENT_CONFIRMATION_PERCENTAGE_BY_BRANCH:
      return {
        ...state,
        appointmentConfirmationPercentageByBranch: action.payload,
      };
    case GET_GENERAL_CUSTOMER:
      return {
        ...state,
        generalCustomer: action.payload,
      };
    case GET_GENERAL_APPOINTMENTS:
      return {
        ...state,
        generalAppointment: action.payload,
      };

    case GET_GENERAL_COSMETOLOGIC_FEES:
      return {
        ...state,
        generalCosmetologicFees: action.payload,
      };
    case GET_INDIVIDUAL_COMMISSION_MEDICAL:
      return {
        ...state,
        individualCommissionMedical: action.payload,
      };

    case GET_SCHEDULED_APPOINTMENTS:
      return {
        ...state,
        generalScheduledAppointments: action.payload,
      };

    case GET_COSMETOLOGIC_FEE_BY_COSMETOLOGIST:
      return {
        ...state,
        cosmetologicFeesByCosmetologist: action.payload,
      };

    case GET_MONTHLY_SALES:
      return {
        ...state,
        monthlySales: action.payload,
      };
    case GET_DAILY_CASH_CLOSING:
      return {
        ...state,
        dailyCashClosing: action.payload,
      };

    case GET_DAILY_SALES:
      return {
        ...state,
        dailySales: action.payload,
      };
    case GET_OCCUPATION_BY_BRANCH:
      return {
        ...state,
        occupationByBranch: action.payload,
      };
    case CLEAR_GENERAL_APPOINTMENT:
      return {
        ...state,
        generalAppointment: [],
      };
    case CLEAR_GENERAL_CUSTOMER:
      return {
        ...state,
        generalCustomer: [],
      };
    case CLEAR_MEDICAL_COMMISSIONS_BY_BRANCH:
      return {
        ...state,
        medicalComissionByBranch: [],
      };
    case CLEAR_MEDICAL_COMMISSION:
      return {
        ...state,
        medicalComissionByBranch: [],
      };
    case CLEAR_COSMETOLOGISC_FEES_BY_COMESTOLOGIST:
      return {
        ...state,
        cosmetologicFeesByCosmetologist: [],
      };
    case CLEAR_BRANCH_EXPENSES:
      return {
        ...state,
        expensesByBranch: [],
      };
    case CLEAR_DAILY_CASH_CLOSING:
      return {
        ...state,
        dailyCashClosing: [],
      };
    case CLEAR_GENERAL_INVENTORY:
      return {
        ...state,
        generalInventory: [],
      };
    case CLEAR_APPOINTMENT_CONFIRMATION_PERCENTAGE_REPORT_BY_BRANCH_FILTERS:
      return {
        ...state,
        appointmentConfirmationPercentageByBranch: [],
      };
    case CLEAR_MONTHLY_SALES:
      return {
        ...state,
        monthlySales: [],
      };
    case CLEAR_GENERAL_INVENTORY_FILTERS:
      return {
        ...state,
        generalInventory: [],
      };
    case CLEAR_GENERAL_SCHEDULED_APPOINTMENT:
      return {
        ...state,
        generalScheduledAppointments: [],
      };
    case CLEAR_STOCK_BY_BRANCH_REPORT:
      return {
        ...state,
        stockByBranch: [],
      };
    case CLEAR_DAILY_SALES:
      return {
        ...state,
        dailySales: [],
      };
    case CLEAR_GENERAL_COSMEOTLOGIC_FEES:
      return {
        ...state,
        generalCosmetologicFees: [],
      };
    case CLEAR_INDIVIDUAL_COMMISSION_MEDICAL:
      return {
        ...state,
        individualCommissionMedical: [],
      };
    case CLEAR_PROFITABILITY_BY_BRANCH:
      return {
        ...state,
        profitabilityByBranch: [],
      };
    case CLEAR_GENERAL_EXPENSES:
      return {
        ...state,
        generalExpenses: [],
      };
    case CLEAR_OCCUPATION_BY_BRANCH:
      return {
        ...state,
        occupationByBranch: [],
      };
    default:
      return state;
  }
}
